import React from 'react'
import { checkTextTranslation, imageAddress } from '../../utils/useful'

class SlideView extends React.Component {
    state = {
    }



    slideChanged = () => {

        this.pauseAudio()
    }


    playAudio = () => {
        if (this.audioPlayer) {
            this.audioPlayer.play()
            this.setState({ isPlaying: true })
        }
    }

    pauseAudio = () => {
        if (this.audioPlayer) {
            this.audioPlayer.pause()
            this.setState({ isPlaying: false })

        }
    }

    render() {
        let item = this.props.data
        return (
            <div >
                <div className='py-4 px-4 d-flex flex-column position-relative' style={{ height: (350 - 20) * 16 / 9, color: item.textColor ?? '#fff', background: (item.backgroundImage ? ("url(" + imageAddress(item.backgroundImage) + ")") : (item.backgroundColor ?? 'linear-gradient(#FF3B30, #ff3030)')), backgroundSize: 'cover', backgroundPosition: 'center', }}>


                    {item.video && (
                        <div className='w-100 h-100' style={{ position: 'absolute', top: 0, left: 0 }}>
                            <video controls={true} autoPlay={true} className='w-100 h-100' style={{ objectFit: 'cover' }} ref={el => this.videoPlayer = el} src={imageAddress(item.video)} />
                        </div>

                    )}


                    {item.title && item.type != 'audio' && (
                        <p className='text-bold text-big text-center pt-3 zindex-1' style={{ zIndex: 1 }}>{item.title}</p>
                    )}


                    {item.audio && (
                        <div className=' flexcc flex-column zindex-1' style={{ zIndex: 1, flex: 1 }}>
                            <audio className='d-none' ref={el => this.audioPlayer = el} onEnded={() => this.pauseAudio} src={imageAddress(item.audio)} />
                            <img src='/images/gramafon.jpg' height={170} style={{ borderRadius: 200 }} />

                            {item.title && item.type == 'audio' && (
                                <p className='text-bold text-big text-center pt-3'>{item.title}</p>
                            )}

                            {item.description && item.type == 'audio' && (
                                <div className=' flexcc' style={{}}>
                                    <p className='text-center' style={{}}>{item.description}</p>
                                </div>
                            )}
                            {!this.state.isPlaying && (
                                <button className='mt-2' onClick={() => this.playAudio()}>
                                    <img src='/images/play.png' height={60} style={{}} />
                                </button>
                            )}

                            {this.state.isPlaying && (
                                <button className='mt-2' onClick={() => this.pauseAudio()}>
                                    <img src='/images/pause.png' height={60} style={{}} />
                                </button>
                            )}

                        </div>
                    )}




                    {item.question && (
                        <div className=' d-flex text-right mt-4' style={{ zIndex: 1, }}>
                            <p className='text-right w-100' style={{}}>{item.question}</p>
                        </div>
                    )}

                    {item.options && item.type != 'testResult' && (
                        <div className=' d-flex flex-column text-right mt-4' style={{ zIndex: 1, direction: 'rtl' }}>
                            {item.options.map((prop, index) => {
                                return (
                                    <button className='flexc mt-3 p-0' >
                                        <div style={{ height: 20, width: 20, borderRadius: 20, backgroundColor: '#fff', border: '1px solid #eee' }}>
                                        </div>
                                        <div className='mx-2'>
                                            <p className='text-small ' style={{ color: item.textColor ?? '#fff' }}>{prop.name}</p>
                                        </div>
                                    </button>
                                )
                            })}
                        </div>
                    )}


                    {item.options && item.type == 'testResult' && (
                        <div className=' flexcc text-center ' style={{ zIndex: 1, flex: 1, direction: 'rtl' }}>
                            <p className='text-normal ' style={{ color: item.textColor ?? '#fff', marginTop: -30 }}>جواب تست با توجه به سوالات پاسخ توسط کاربر در اینجا جایگاه به کاربر نمایش داده میشود</p>

                        </div>
                    )}


                    {item.description && item.type != 'audio' && (
                        <div className=' flexcc' style={{ zIndex: 1, flex: 1 }}>
                            <p className='text-center' style={{ marginTop: -30 }}>{item.description}</p>
                        </div>
                    )}


                </div>
            </div>
        )
    }
}

export default SlideView;